import React from 'react';
import { usePeers } from 'app/containers/rtc/PeersContext';
import { usePeersPlayback } from 'app/containers/rtc/PeersPlaybackContext';
import Peer from 'app/services/rtc/Peer';
import PositionedVideo, { Position } from 'app/components/rtc/PositionedVideo';
import {
  createRecycledComponent,
} from 'app/components/utilities/RecycledComponentsProvider';

interface IProps {
  mirror?: boolean;
  id: Peer['id'];
}

const PeerVideo: React.FC<IProps> = ({
  mirror, id,
}) => {
  const peers = usePeers();
  const peer = peers.get(id);

  const playback = usePeersPlayback();

  if (peer === undefined || playback === undefined) {
    return null;
  }

  const { videoStream } = peer;

  if (videoStream === undefined) {
    return null;
  }

  return (
    <PositionedVideo
      mirror={mirror}
      src={videoStream}
      playback={playback}
      disableAudio
      disableBackground
      position={Position.AbsoluteFullWidth}
    />
  );
};

export default createRecycledComponent(
  PeerVideo,
  props => `peerVideo-${props.id}`,
);
